import axios from 'axios'

const api = axios.create({
    baseURL: "https://api-zausodev.zauso-dev.com.br",
    headers: {
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    }
})

export default api;